import React, {useEffect} from 'react';
import {Route, Switch, useHistory} from 'react-router-dom';
import asyncComponent from '../../../util/asyncComponent';
import {useDispatch, useSelector} from "react-redux";
import {
    bbFindEntityWithinPortfolioOrSelf,
    bbDoesUserHaveAccessToBreachRiskLevelForEntity,
    getFirstCustomerId,
    getFirstEntityId,
    isCurrentUserMemberOf,
    filterObject,
    bbIsBetasOk,
    showBBNotification,
    bbDoesUserHaveAccessToBreachRiskLevelForAnyEntity,
    bbFindSubportfolioWithinPortfolio, bbFindCustomerTagsByTagId, bbDoesCustomerHaveAccessToSubscription,
} from "../../../util/bbHelpers";
// import Score from "../../../../../Archive/OldBRPortfolioOverview/Overview";
import DetailsScores from "./routes/Details/Scores";
import DetailsReports from "./routes/Details/Reports";
import DetailsTechDataForAdminsAndTrustedAgentsOnly from "./routes/Details/PortfolioTechnicalForAdminsOnly";
import DetailsVerificationsForAdminsAndTrustedAgentsOnly from "./routes/Details/VerificationsPortfolioView";
import InsightPage from "./routes/Insights";
import ManagePortfolio from "./routes/ManagePortfolio";
import {
    fetchCustomers, fetchCycleSocialPagewise,
    fetchRiskCycleDetailsPagewise,
    fetchRiskCycleReport,
    fetchRiskPortfolio,
    setCustomerInView,
    setEntityInView
} from "../../../actions";
import URLSearchParams from "url-search-params";
import MultiCustomerBRWrapper from "../brbusiness/routes/MultiCustomerBRWrapper";
// import SubscriptionBRExpiredModal from "../../../components/customBreachBits/modals/SubscriptionBRExpiredModal";
import {INFO} from "../../../constants/ActionTypes";
import CloudIntegrationsPortfolio from "./routes/PortfolioAdministratorPages/CloudIntegrationsPortfolio";
import AttestationsPortfolio from "./routes/PortfolioAdministratorPages/AttestationsPortfolio";
import SocialPortfolioView from "./routes/Details/SocialPortfolioView";
import SubscriptionNotActiveModal from "../../../components/customBreachBits/modals/SubscriptionNotActiveModal";

function PageRoutes({match, isAdmin, isTrustedAgent, isAdministratorForAnyEntity}) {
    return(
        <>
            {/*<SubscriptionBRExpiredModal subscriptionTypeId={1}>*/}
        <Switch>
            {/*<Redirect exact from={`${match.url}`} to={`${match.url}`}/>*/}
            {/*<Route path={`${match.url}/Overview`} component={Score}/>*/}
            <Route path={`${match.url}/Insights`} component={InsightPage}/>
            <Route path={`${match.url}/Details/Scores`} component={DetailsScores}/>
            <Route path={`${match.url}/Details/Reports`} component={DetailsReports}/>
            <Route path={`${match.url}/Manage`} component={ManagePortfolio}/>
            {(isAdmin || isTrustedAgent) &&
                <>
                    <Route path={`${match.url}/Details/TechData`} component={DetailsTechDataForAdminsAndTrustedAgentsOnly}/>
                    <Route path={`${match.url}/Details/Social`} component={SocialPortfolioView}/>
                    <Route path={`${match.url}/Details/Verifications`} component={DetailsVerificationsForAdminsAndTrustedAgentsOnly}/>
                    <Route path={`${match.url}/CloudIntegration`} component={CloudIntegrationsPortfolio}/>
                    <Route path={`${match.url}/Attestations`} component={AttestationsPortfolio}/>
                </>
            }
            {/*{(isAdmin || isAdministratorForAnyEntity)*/}
            {/*    && <>*/}

            {/*    </>*/}
            {/*}*/}

            <Route component={asyncComponent(() => import('app/routes/extraPages/routes/404'))}/>
        </Switch>
            {/*</SubscriptionBRExpiredModal>*/}
            </>
    );
}

const Pages = ({match}) => {

    const {customers, customerInView} = useSelector(({customer}) => customer);
    const {authUser} = useSelector(({auth}) => auth);
    const history = useHistory();
    const dispatch = useDispatch();
    const numCustomers = customers ? Object.keys(customers).length : 0;

    const customer = customers ? customers[customerInView] : null;

    const {entityInView, portfolios, loadingPortfolios, loadingCycles, selfEntityId, loadingCycleDetails, loadingCycleSocial} = useSelector(({breachrisk}) => breachrisk);

    const customerIdToUse = customers ? customerInView ? customerInView : null : null;

    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerIdToUse);

    // const entities = portfolios
    // && portfolios[customerInView]
    //     ? filterObject(portfolios[customerInView].entities, (_, entity) => entity.id !== selfEntityId)
    //     : null;
    //
    // const myEntity = entities
    // && entityInView
    //     ? entities[entityInView]
    //     : null;
    // const myEntity = portfolios ? portfolios[customerIdToUse] ? portfolios[customerIdToUse].entities ? selfEntityId ? portfolios[customerIdToUse].entities[selfEntityId] : null : null : null : null;

    // console.log("Portfolio pages. myEntity", myEntity, "portfolios", portfolios, "selfEntityId", selfEntityId)

    const isTrustedAgent = bbDoesUserHaveAccessToBreachRiskLevelForAnyEntity(authUser, "infoLevel3");
    const isAdministratorForAnyEntity= bbDoesUserHaveAccessToBreachRiskLevelForAnyEntity(authUser, "infoLevel4")
    const isPartner = isCurrentUserMemberOf(authUser, "partner");
    const isAdmin =  isCurrentUserMemberOf(authUser, "admin");
    const isStaff = isCurrentUserMemberOf(authUser, "staff");
    const subscriptions = customer && Object.values(customer.Subscriptions)
    const hasActiveBRPSubscription = subscriptions && subscriptions.filter((sub)=> sub.subscription_type && sub.subscription_type.id === 1 && sub.is_active).length;
    const isBRPortfolioCustomer = hasActiveBRPSubscription || bbDoesCustomerHaveAccessToSubscription(customer, 1);
    const hasBRPortfolioRole  = isCurrentUserMemberOf(authUser,"breachrisk_portfolio")


    useEffect(() => {

        if (customers == null && authUser) {
            // console.log("Customers is empty, fetching from CIRTPages. numCustomers is ", numCustomers);
            dispatch(fetchCustomers());
        }
        if (numCustomers && customerInView === null) {
            const defaultId = getFirstCustomerId(customers);
            // console.log("setting view to default customer, first in list: ", defaultId);
            dispatch(setCustomerInView(defaultId));
        }



        /*  jfd*******************************
                 *   Fetch Portfolios
                     ********************************** */

        if (customers && customer && authUser && !portfolios && !loadingPortfolios[customerInView]) {
            // console.log("Portfolios is empty, fetching for customerId", customer.CustomerId);
            dispatch(fetchRiskPortfolio({
                customerId: customer.CustomerId
            }));
        }

        /*  jfd*******************************
                 *   Fetch The latest cycle for the entityInView
                     ********************************** */
        //TODO: add logic so this is only done if their subscription includes BR Report

        // console.log("Checking to see if last cycle is already loaded", myEntity);
        if (entityInView
            && myEntity
            && authUser
            && bbDoesUserHaveAccessToBreachRiskLevelForEntity(authUser, "infoLevel2", myEntity.id)
            && myEntity.settings
            && myEntity.settings.last_cycle_id
            && (!myEntity.cycles || !myEntity.cycles[myEntity.settings.last_cycle_id])
            && !loadingCycles[myEntity.settings.last_cycle_id]) {
            // console.log("Portfolio fetch latest cycle using myEntity of ", myEntity, "and authUser of", authUser);
            dispatch(fetchRiskCycleReport({
                cycleId: myEntity.settings.last_cycle_id,
                customerId: customerIdToUse
            }));
        }

        /*  jfd*******************************
         *   Set entityInView
             ********************************** */
        const filteredEntitiesWithoutSelf = portfolios && portfolios[customerIdToUse] ? filterObject(portfolios[customerIdToUse].entities, (_, entity) => entity.id !== selfEntityId) : null
        if (filteredEntitiesWithoutSelf
            && !bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerIdToUse, true)
        ) {
            const defaultId = getFirstEntityId(filteredEntitiesWithoutSelf);
            // console.log("setting view to default customer, first in list: ", defaultId);
            dispatch(setEntityInView(defaultId));
            // console.log("set the entity in view to", defaultId);
        }


        /*  jfd*******************************
                 *   Fetch The latest cycle details (tech data) should only be done if user is admin or a trusted agent
                     ********************************** */

        // console.log("Checking to see if last cycle is already loaded", myEntity, "authUser", authUser, "loadingCycles", loadingCycles, "loadingCycleDetails", loadingCycleDetails);
        if (myEntity
            && authUser
            //restore this next line to reproduce the admin/trusted agent error where won't load Tech page
            // && isCurrentUserMemberOf(authUser, "admin")
            && (isCurrentUserMemberOf(authUser, "admin") || bbDoesUserHaveAccessToBreachRiskLevelForEntity(authUser, "infoLevel3", myEntity.id))
            && bbDoesUserHaveAccessToBreachRiskLevelForEntity(authUser, "infoLevel3", myEntity.id)
            && myEntity.settings
            && myEntity.settings.last_cycle_id
            && myEntity.cycles
            && myEntity.cycles[myEntity.settings.last_cycle_id] //if there is already a cycle
            && !loadingCycles[myEntity.settings.last_cycle_id]
            && !loadingCycleDetails[myEntity.settings.last_cycle_id] //if not already loading them
        ) {
            console.log("Checking tech data for last cycle to see if need to fetch for cycle (",myEntity.settings.last_cycle_id,").", myEntity);
            const techData = myEntity.cycles[myEntity.settings.last_cycle_id].techData
            //determine what page should be fetched.
            var pageNumToFetch = null;

            //if there is no techData, then fetch page 1.
            if (!techData){ //if no tech data
                console.log("There is no techData. setting page to fetch as 1. techData", techData);
                pageNumToFetch = 1;
            } else if ( //if there are pages that have not yet been fetched (first version of this Dec '21 will be simple and assume previous pages have been fetched)
                //TODO: Logic of this should be more robust. Figure out how to tell which records are missing so you can fetch the correct page?
                //look at the techData meta to see the highest page number that has been fetched
                //compare this to the number of pages available
                //if there are more pages to fetch
                techData.meta
                && techData.meta.highestPageFetched
                && techData.meta.pages
                && techData.meta.highestPageFetched < techData.meta.pages
            ) {
                //set the next page to fetch as the next highest page
                pageNumToFetch = techData.meta.highestPageFetched + 1;

                console.log("TechData Loader. pageNumToFetch set to", pageNumToFetch)

                //some load times can be long - give users occasional notifications
                //every 10th page, let them know.
                // if (pageNumToFetch % 30 === 0) {
                //     const percentCompleteLoading = Math.floor(pageNumToFetch/techData.meta.pages * 100) ;
                //     showBBNotification(INFO, "Loading BreachRisk™ Technical In Progress", `${percentCompleteLoading}% complete, now fetching segment ${pageNumToFetch} of ${techData.meta.pages}`, false);
                // }


            } else if (
                techData.meta
                && techData.meta.highestPageFetched
                && techData.meta.pages
                && techData.meta.highestPageFetched >= techData.meta.pages) {

                //no need to fetch a page because highest page meet or exceeds max pages.
                console.log("All tech details pages have been fetched. Won't fetch.", techData.meta.highestPageFetched, "out of", techData.meta.pages);
                pageNumToFetch = null;

                //if there were a lot of pages, let them know loading is complete
                // if (techData.meta.pages > 2) {
                //     // const percentCompleteLoading = Math.floor(pageNumToFetch/techData.meta.pages) * 100;
                //     showBBNotification(SUCCESS, "Loading BreachRisk™ Technical Complete", `Loading complete. ${techData.meta.pages} data segments loaded.`, false);
                // }

            } else {
                console.warn("brportfolio/index Unexpected reason to not fetch another tech details page. Will not fetch. techData", techData, "pageNumToFetch", pageNumToFetch, "myEntity", myEntity, "customerIdToUse", customerIdToUse )
                pageNumToFetch = null;
            }

            //if we got a valid page number, fetch the details
            if (pageNumToFetch) {
                console.log("Fetching techData details page", pageNumToFetch);
                dispatch(fetchRiskCycleDetailsPagewise(
                    myEntity.settings.last_cycle_id,
                    customerIdToUse,
                    pageNumToFetch
                ));
            }
        }

        /*  *******************************
                 *   Fetch The latest social details (social)
                 * This should only be done if admin or trusted agent.
                 * The throttle social calls fix used in BRfB is not used here
                 * Should NOT fetch if they have the "don't do social engineering" tag, which is ID of 80
                 * https://breachbits.slack.com/archives/GSH388GM9/p1668545389712269
                     ********************************** */

        const dontDoSocialTags = bbFindCustomerTagsByTagId(customer, 80);
        const dontDoSocial = dontDoSocialTags && dontDoSocialTags.length > 0; //if there is at least one dont social tag, then qualifies
        // console.log("checking for social tag within brbusiness/index.js", "customer", customer, "dontDoSocialTags", dontDoSocialTags, "dontDoSocial", dontDoSocial);

        const highestPageFetchedSocial = myEntity
            && myEntity.cycles
            && myEntity.settings
            && myEntity.settings.last_cycle_id
            && myEntity.cycles[myEntity.settings.last_cycle_id]
            && myEntity.cycles[myEntity.settings.last_cycle_id].social
            && myEntity.cycles[myEntity.settings.last_cycle_id].social.cycleTotals
            && myEntity.cycles[myEntity.settings.last_cycle_id].social.cycleTotals.highestPageFetched;

        // const throttleSocialCall = !hasPremiumSubscription
        //     && (highestPageFetchedSocial >= 1);

        // console.log("This is about throttling social calls-- highestPageFetchedSocial", highestPageFetchedSocial, "throttleSocialCall", throttleSocialCall);
        if (myEntity
            && authUser
            && !dontDoSocial
            // && !throttleSocialCall
            && bbDoesUserHaveAccessToBreachRiskLevelForEntity(authUser, "infoLevel3", myEntity.id)
            // && (myEntity.pro_subscription || myEntity.premium_subscription)
            //TODO: restore this check for Lite subscription once we update such that all tiles on tech page only rely on summary data (see Slack convo https://breachbits.slack.com/archives/GLM5SQC2Z/p1657044367751359)
            // && (doesUserHaveALiteSubscriptionOrHigher || isAdmin || isStaff)
            && myEntity.settings
            && myEntity.cycles
            && myEntity.cycles[myEntity.settings.last_cycle_id] //if there is already a cycle
            && !loadingCycles[myEntity.settings.last_cycle_id]
            // && !myEntity.cycles[myEntity.settings.last_cycle_id].techData //if no tech data
            && !loadingCycleSocial[myEntity.settings.last_cycle_id] //if not already loading them)
            // && !myEntity.cycles[myEntity.settings.last_cycle_id].social
        ){
            const social = myEntity.cycles[myEntity.settings.last_cycle_id].social;

            let pageNumToFetch = null;
            const totalPages = social && social.cycleTotals && social.cycleTotals.pages;
            // const highestPageToFetch = social && social.totals && social.totals.number_identities && social.totals.page_size &&
            //     social.totals.number_identities / social.totals.page_size;
            const pageSize = social && social.page_size;
            const highestPageFetched = social && social.cycleTotals && social.cycleTotals.highestPageFetched;
            console.log("what is highestPageFetched", social && social.cycleTotals && social.cycleTotals.highestPageFetched)

            if(!social){
                pageNumToFetch = 1;
            } else if (social.cycleTotals
                && social.cycleTotals.pages
                && social.cycleTotals.highestPageFetched
                && social.cycleTotals.highestPageFetched < social.cycleTotals.pages){
                pageNumToFetch = social.cycleTotals.highestPageFetched + 1;

                console.log("pageNumber to Fetch being sent", pageNumToFetch)

                //highestPageFetched needs to be added to local state to track better
                // highestPageFetched = highestPageFetched + 1;

                // if(pageNumToFetch % 30 === 0){
                //     const percentCompleteLoading = Math.floor(pageNumToFetch/totalPages * 100);
                //     showBBNotification(INFO, "loading BreachRisk™ Social In Progress", `${percentCompleteLoading}% complete, now fetching segment ${pageNumToFetch} of ${totalPages}`, false);
                // }
            }else if (
                social.cycleTotals
                && social.cycleTotals.pages
                && social.cycleTotals.highestPageFetched
                && social.cycleTotals.highestPageFetched >= social.cycleTotals.pages
            ){
                console.log("All Social detail pages have been fetched. Won't fetch.", social.cycleTotals.highestPageFetched, "out of", totalPages);
                pageNumToFetch=null;
            } else{
                console.warn("brbusiness2 Unexpected reason to not fetch another social page. Will not fetch. social", social, "pageNumToFetch", pageNumToFetch, "myEntity", myEntity,
                    "social.cycleTotals",
                    social.cycleTotals,
                    "social.cycleTotals.pages",
                    social.cycleTotals.pages,
                    "social.cycleTotals.highestPageFetched",
                    social.cycleTotals.highestPageFetched,
                    "social.cycleTotals.highestPageFetched >= social.cycleTotals.pages",
                    social.cycleTotals.highestPageFetched >= social.cycleTotals.pages
                )
                pageNumToFetch=null;
            }

            if(pageNumToFetch){
                dispatch(fetchCycleSocialPagewise(
                    myEntity.settings.last_cycle_id,
                    customerIdToUse,
                    myEntity.id,
                    pageNumToFetch,
                ));
            }

        }




        /*  jfd*******************************
         *   Appending clientID to URL
             ********************************** */
        const params = new URLSearchParams(window.location.search);

        if ((isPartner
            || isAdmin
            || isStaff
        )) {
            //if they are a partner, staff, or admin, append the clientID search param

            if(customers
                && !params.has("clientID")
                && customerInView
            ) {
                //set the urlParameters
                params.set("clientID", customerInView)
                // console.log("getting params", params.get("clientID"));
                history.replace({
                    search: params.toString(),
                })
            }
        }

    }, [dispatch, customers, portfolios, customerInView, entityInView, authUser, customer, customerIdToUse, history, isAdmin, isPartner, isStaff,
                loadingCycles, loadingPortfolios, myEntity, numCustomers, loadingCycleDetails]);

    if ((isAdmin || isStaff) ) {
        return (
            <MultiCustomerBRWrapper customer={customers ? customers[customerIdToUse] : null}>
                <PageRoutes match={match} betasOk={bbIsBetasOk(authUser)} isAdmin={isAdmin} isTrustedAgent={isTrustedAgent}/>
            </MultiCustomerBRWrapper>
        )
    } else
        if(isBRPortfolioCustomer && hasBRPortfolioRole)
        // { //(!authUser.customers && !authUser.customers.isEmpty()) || (authUser.customers && authUser.customers.length > 1)) {
        return (
                <PageRoutes match={match} isTrustedAgent={isTrustedAgent} isAdministratorForAnyEntity={isAdministratorForAnyEntity}/>
        )
    // }
    else if(isBRPortfolioCustomer || hasBRPortfolioRole){
        return(
            <>
                {customer && <SubscriptionNotActiveModal/>}
                <PageRoutes match={match} isTrustedAgent={isTrustedAgent} isAdministratorForAnyEntity={isAdministratorForAnyEntity}/>
            </>
        )
    } else{
            return (
                <Route component={asyncComponent(() => import('app/routes/extraPages/routes/404'))}/>
            )
        }
};

export default Pages;
